var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-copy-content--container"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('LsButton',{attrs:{"text":"Copy","test-id":"copy","track-id":"ls_copy_content-copy","min-width":false},on:{"click":_vm.onCopy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }